import React from 'react';
import { GoogleIcon, SpinnerIcon } from '../../../components/Icons';
import { CIEN_CUADRAS_BUTTON_BLUE } from '../../../constants';

interface GoogleAuthButtonProps {
  onGoogleSignIn: () => Promise<boolean>;
  isLoading: boolean;
}

export const GoogleAuthButton: React.FC<GoogleAuthButtonProps> = ({ onGoogleSignIn, isLoading }) => {
  return (
    <div className="space-y-4">
      <div className="relative my-4">
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-gray-200" />
        </div>
        <div className="relative flex justify-center text-xs uppercase tracking-wider font-semibold">
          <span className="px-3 bg-white text-gray-500">O continúa con</span>
        </div>
      </div>
      <button
        type="button"
        onClick={onGoogleSignIn}
        disabled={isLoading}
        className="w-full flex items-center justify-center py-2.5 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-semibold bg-white text-gray-700 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-sky-500 disabled:opacity-60 transition-colors"
      >
        {isLoading ? (
          <SpinnerIcon className="w-5 h-5 text-gray-600 mr-2" />
        ) : (
          <GoogleIcon className="w-5 h-5 mr-2" />
        )}
        Continuar con Google
      </button>
    </div>
  );
};
